var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showIframe)?_c('iframe',{staticClass:"fill-height fill-width home",attrs:{"src":_vm.$universe.data().home_url}}):_c(_vm.universeComponent,{tag:"component",staticClass:"fill-height fill-width home"})
}
var staticRenderFns = []

export { render, staticRenderFns }